import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getCopy } from '../../data/siteCopy';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const { language, toggleLanguage } = useLanguage();
  const copy = getCopy(language);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/' || location.pathname.startsWith('/project');
    }
    return location.pathname === path;
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          Augusta Silva
        </Link>
        <div className="header-actions">
          <nav className="header-nav">
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
            >
              {copy.nav.work}
            </Link>
            <span className="nav-separator">·</span>
            <Link 
              to="/about" 
              className={`nav-link ${isActive('/about') ? 'active' : ''}`}
            >
              {copy.nav.about}
            </Link>
            <span className="nav-separator">·</span>
            <Link 
              to="/contact" 
              className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            >
              {copy.nav.contact}
            </Link>
          </nav>

          <button
            type="button"
            className="language-toggle"
            onClick={toggleLanguage}
            aria-label={copy.nav.toggleLabel}
            title={copy.nav.toggleLabel}
          >
            <span className={`language-toggle-indicator ${language === 'en' ? 'right' : 'left'}`} />
            <span className="language-toggle-label">PT</span>
            <span className="language-toggle-label">EN</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
